import React from 'react';

type PetIconProps = React.SVGProps<SVGSVGElement> & { size?: number | string };

/**
 * Pet icon component
 * Custom SVG illustration from .graphics/client/pets.svg
 */
export const PetIcon: React.FC<PetIconProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      width={size ?? width ?? 24}
      height={size ?? height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient id="petLinearGradient">
          <stop stopColor="#c5c5c5" stopOpacity={1} offset="0" />
          <stop stopColor="#808080" stopOpacity={1} offset="1" />
        </linearGradient>
        <radialGradient
          id="petRadialGradient"
          cx="11.368145"
          cy="18.694866"
          fx="11.368145"
          fy="18.694866"
          r="11.429989"
          gradientTransform="matrix(0.98487467,-0.17326824,0.12476417,0.70917251,-90.597619,-4.0484521)"
          gradientUnits="userSpaceOnUse"
          href="#petLinearGradient"
        />
      </defs>
      <g transform="translate(88.266817,9.6623637)">
        {/* Body */}
        <path
          fill="url(#petRadialGradient)"
          stroke="none"
          strokeWidth="0.133077px"
          d="m -84.79277,2.1442711 0.521237,9.7545839 2.233875,-0.148925 1.191399,-4.0954359 c 1.592859,-1.522041 4.948652,-0.223388 7.446246,-0.29785 l 1.340326,4.5422109 2.531725,0.148925 0.148924,-12.50969486 2.978498,1.340324 1.563712,-3.27634784 -5.43576,-3.1274238 -0.992332,-1.847145 -1.683803,0.622398 c -0.05091,1.6746445 0.06485,2.2639138 -0.427957,3.6734185 -0.492809,1.4095047 -0.705158,1.9599557 -1.214734,3.35940014 l -8.190869,0.29785 c -2.408416,-0.256863 -3.404698,-2.77313904 -4.914523,-4.46774714 0.443891,2.92769934 1.68767,4.45559314 2.904036,6.0314591 z"
        />
        {/* Tail */}
        <path
          fill="#b1744f"
          fillOpacity={1}
          stroke="none"
          strokeWidth="0.133077px"
          d="m -72.980656,-5.1062058 c -0.02641,0.650644 -0.104209,1.19893 -0.394531,2.029297 1.224797,-0.030111 2.596039,1.515126 3.99414,2.86132794 l 0.002,-0.246093 2.978516,1.339843 1.404297,-2.94140694 c -2.020783,-0.866249 -5.732798,-1.758743 -7.984422,-3.042968 z"
        />
        {/* Snout */}
        <path
          fill="#b36363"
          fillOpacity={1}
          stroke="none"
          strokeWidth="0.133077px"
          d="m -74.633077,0.12850114 c -0.02226,0.06101 -0.03317,0.08985 -0.05664,0.154297 l -7.632813,0.277344 c -0.286236,0.63864496 -0.329386,1.30138696 0.248047,1.80663996 0.895181,0.783283 2.864872,0.394464 3.753906,1.085938 0.814066,0.633164 2.608447,2.294508 3.457032,1.779296 1.715798,-1.041735 1.681794,-3.489013 0.230468,-5.10351496 z"
        />
        {/* Left leg */}
        <path
          fill="#b2744e"
          fillOpacity={1}
          stroke="none"
          strokeWidth="0.133077px"
          d="m -84.548826,2.7291031 c -0.06672,-2.62e-4 -0.131705,0.0012 -0.197265,0.002 l 0.361328,6.767578 c 2.090261,0.003 1.365317,-1.661297 1.455078,-2.917968 0.09878,-1.382943 2.074944,-2.667606 0.296875,-3.556641 -0.452438,-0.226219 -1.208524,-0.292145 -1.916016,-0.294922 z"
        />
        {/* Eye */}
        <g transform="matrix(0.51193347,0,0,0.51193347,-77.512248,-8.8722039)">
          <path fill="#241c1c" fillOpacity={1} stroke="none" d="m 16,10 h 0.01" />
          <path
            fill="#241c1c"
            fillOpacity={1}
            stroke="none"
            d="m 16.559322,9.568359 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 0.0098 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z"
          />
        </g>
        {/* Ear */}
        <path
          fill="#b36363"
          fillOpacity={1}
          stroke="none"
          strokeWidth="0.133077px"
          d="m -71.265162,-7.3720642 -1.683594,0.621094 c -0.503074,1.674643 -0.421876,2.2295441 -0.427734,3.673828 -0.0034,0.00974 -0.0044,0.013783 -0.0078,0.023438 0.217398,1.1491748 1.135608,1.0969561 1.978516,1.173828 1.742871,-0.5977515 1.718066,-1.0692404 2.271484,-1.582031 l -0.363281,-1.615235 -0.77539,-0.447265 z"
        />
      </g>
    </svg>
  );
};

